import { ProductDetailsType } from 'types/ProductDetailsType';

/**
 * Determines whether a review is part of the experience. This is true when
 * either:
 *  1. A review module is attached to the registration flow
 *     (registration.attachedModuleType === 'REVIEW'), or
 *  2. A standalone reviews module exists in the "more" modules list
 *     (a module of type 'REVIEWS_MODULE').
 *
 * Used to gate iovation fingerprinting so it only loads when a review is
 * actually part of the experience.
 */
const hasReviewInExperience = (
  productDetails: ProductDetailsType | null | undefined
): boolean => {
  if (!productDetails) return false;

  // 1. Review module attached to the registration flow
  const attachedModuleType = String(
    (productDetails.registration as any)?.attachedModuleType || ''
  ).toUpperCase();
  if (attachedModuleType === 'REVIEW') return true;

  // 2. Standalone reviews module in the "more" modules list
  return !!productDetails.modules?.some(
    (module) => module.type === ('REVIEWS_MODULE' as any)
  );
};

export default hasReviewInExperience;
